export * from './alias.component';
